import type { RouteRecordRaw } from 'vue-router'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'
import { UserSettingsRoutes } from '@/routes/user/settings'
import { campaignSendersDomainRouteParamId } from '@/routes/user/messenger/types'

export const getOldFacebookRoutes = (): RouteRecordRaw[] => [
  {
    name: 'user.chats.settings.facebook',
    path: 'facebook',
    redirect: { name: UserSettingsRoutes.FacebookIndex },
    children: [
      getOldRouteWithRedirect('user.chats.settings.facebook.flow', 'flow', UserSettingsRoutes.FacebookFlow),
      getOldRouteWithRedirect('user.chats.settings.facebook.details', ':id', UserSettingsRoutes.FacebookDetails),
    ],
  },
]

export const getOldInstagramRoutes = (): RouteRecordRaw[] => [
  {
    name: 'user.chats.settings.instagram.index',
    path: 'instagram',
    redirect: { name: UserSettingsRoutes.InstagramIndex },
    children: [
      getOldRouteWithRedirect('user.chats.settings.instagram.flow', 'flow', UserSettingsRoutes.InstagramFlow),
      getOldRouteWithRedirect('user.chats.settings.instagram.details', ':id', UserSettingsRoutes.InstagramDetails),
    ],
  },
]

export const getOldWhatsAppRoutes = (): RouteRecordRaw[] => [
  {
    name: 'user.chats.settings.whatsapp',
    path: 'whatsapp',
    redirect: { name: UserSettingsRoutes.WhatsAppIndex },
    children: [
      getOldRouteWithRedirect('user.chats.settings.whatsapp.flow', 'flow', UserSettingsRoutes.WhatsAppFlow),
      getOldRouteWithRedirect(
        'user.chats.settings.whatsapp.account',
        'account/:id',
        UserSettingsRoutes.WhatsAppAccount,
      ),
      getOldRouteWithRedirect(
        'user.chats.settings.whatsapp.phone',
        'account/:id/phone/:phoneId',
        UserSettingsRoutes.WhatsAppPhone,
      ),
    ],
  },
]

export const getOldWidgetRoutes = (): RouteRecordRaw[] => [
  {
    name: 'user.chats.settings.web-widget',
    path: 'web-widget',
    redirect: { name: 'user.chats.settings.web-widget.index' },
    children: [
      getOldRouteWithRedirect('user.chats.settings.web-widget.index', '', UserSettingsRoutes.LiveChat),
      getOldRouteWithRedirect('user.chats.settings.web-widget.edit', ':id', UserSettingsRoutes.LiveChatEdit),
    ],
  },
]

export const oldMessengerSettingsEmailsRoute: RouteRecordRaw = {
  name: 'user.messenger.settings.emails',
  path: 'emails',
  redirect: { name: 'user.messenger.settings.emails.index' },
  children: [
    getOldRouteWithRedirect('user.messenger.settings.emails.index', '', UserSettingsRoutes.Email),
    getOldRouteWithRedirect('user.messenger.settings.emails.table', 'domains', UserSettingsRoutes.EmailDomains),
    getOldRouteWithRedirect(
      'user.messenger.settings.emails.flow',
      `flow/:${campaignSendersDomainRouteParamId}?`,
      UserSettingsRoutes.EmailFlow,
    ),
  ],
}
